/* NPM */
import classNames from 'classnames';
import floor from 'lodash/floor';
import { PureComponent } from 'react';
import CountUp from 'react-countup';
/* COMPONENT */
import { ProgressBar } from '@solinkcorp/solink-components';
/* SASS */
import Theme from 'env/theme';
import './PollProgress.sass';

const { colors } = Theme;

class PollProgress extends PureComponent {
  constructor(props) {
    super(props);

    const { percent } = props;
    this.lastPercent = percent;
    this.state = {
      solidComplete: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    const { percent } = this.props;

    if (percent !== prevProps.percent) {
      this.lastPercent = prevProps.percent;
    }
  }

  checkSolidComplete = () => {
    if (this.props.percent !== 100 || !this._isMounted) {
      return;
    }

    this.lastPercent = 100;
    this.setState({ solidComplete: true });
  };

  render() {
    const { barStyle, displayInstruction, displayPercentage, displayProgressBar, locale, percent } =
      this.props;
    const { solidComplete } = this.state;
    let uploadingStatus = '';
    let instruction = '';
    let determinateMode = false;

    if (percent === 0) {
      uploadingStatus = locale.download.statusPreparing;
      instruction = locale.pushToCloudState.preparingInstruction;
    } else if (percent === 100) {
      uploadingStatus = locale.pushToCloudState.completing;
      instruction = locale.pushToCloudState.prepareShareLink;

      if (!solidComplete) {
        determinateMode = true;
      }
    } else {
      uploadingStatus = locale.pushToCloudState.uploading;
      instruction = locale.pushToCloudState.uploadingInstruction;
      determinateMode = true;
    }

    const progressWrapperClass = classNames({
      'poll-progress-bar': displayProgressBar,
      'with-percent-value': displayPercentage,
    });

    return (
      <div id="smart-poll-progress-wrapper" className={progressWrapperClass}>
        <div id="smart-poll-progress">
          {displayProgressBar && determinateMode && (
            <ProgressBar
              className="linear-progress"
              color={colors.blue12}
              mode={'determinate'}
              style={barStyle}
              value={percent}
            />
          )}
          {displayProgressBar && !determinateMode && (
            <ProgressBar
              className="linear-progress"
              color={colors.blue13}
              mode={'indeterminate'}
              style={barStyle}
            />
          )}
          {displayPercentage && (
            <div className="value">
              <CountUp
                duration={1}
                end={floor(percent)}
                start={floor(this.lastPercent)}
                suffix={`%`}
                onComplete={this.checkSolidComplete}
              />
              {displayInstruction && <div className="uploading-status">{uploadingStatus}</div>}
            </div>
          )}
        </div>
        {displayInstruction && <div className="uploading-instruction">{instruction}</div>}
      </div>
    );
  }
}

PollProgress.defaultProps = {
  barStyle: {},
  displayPercentage: true,
  displayProgressBar: true,
  displayInstruction: false,
};

export default PollProgress;
